import React from 'react';
import videos from '../../utils/videos.json';
import './videos.css';

class Videos extends React.Component {
  componentDidMount() {
    const links = document.querySelectorAll('nav a');
    links[1].parentElement.classList += 'active';
  }
  render() {
    return (
      <main>
        <h2>Videos Coming Soon</h2>
        {/*
       <div id="videos">
          {Object
            .keys(videos)
            .map(key => (
              <div className="video-item" key={key}>
                <img src={videos[key].image} alt="test" />
                <div className="video-info">
                  <h2>
                    <a href={videos[key].link}>{videos[key].name}</a>
                  </h2>
                  <p>{videos[key].description}
                  </p>
                </div>
              </div>
            ))
}
        </div>
      */}
      </main>
    );
  }
}

export default Videos;



// WEBPACK FOOTER //
// ./src/components/Portfolio/video.js